import { Autocomplete, Box, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Office } from '../../data';
import { IFormInput } from '../../useWorkContact';

import { useSxStyles } from './useStyles';

type Props = {
  form: UseFormReturn<IFormInput>;
  companyOffice: Office[];
};

export const WorkContactEditMode = (props: Props) => {
  const {
    form: { control },
    companyOffice,
  } = props;

  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const commonFieldProps: Partial<TextFieldProps> = {
    size: 'small',
    fullWidth: true,
  };

  return (
    <Box sx={sxStyles.fieldSet}>
      <Controller
        control={control}
        name={'fEmpPhoneWork'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpPhoneWork')}
              error={!!error?.message}
              helperText={error?.message}
            />
          );
        }}
      />
      <Controller
        control={control}
        name={'fEmpPhoneMob'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpPhoneMob')}
              error={!!error?.message}
              helperText={error?.message}
            />
          );
        }}
      />
      <Controller
        control={control}
        name={'fEmpEmailWork'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpEmailWork')}
              error={!!error?.message}
              helperText={error?.message}
              required={true}
            />
          );
        }}
      />

      <Controller
        control={control}
        name={'fEmpOfficeLoc'}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Autocomplete
            fullWidth={true}
            size={'small'}
            options={companyOffice}
            getOptionLabel={(c) => c.fOfficeCity}
            onChange={(e, value) => {
              onChange(value?.fOfficeId || '');
            }}
            value={companyOffice.find((op) => op.fOfficeId === value) || null}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('fEmpOfficeLoc')}
                required={true}
                error={!!error?.message}
                helperText={error?.message}
              />
            )}
          />
        )}
      />

      <Controller
        control={control}
        name={'fEmpOfficeFloor'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpOfficeFloor')}
              error={!!error?.message}
              helperText={error?.message}
            />
          );
        }}
      />

      <Controller
        control={control}
        name={'fEmpOfficeRoom'}
        render={({ field, fieldState: { error } }) => {
          return (
            <TextField
              {...field}
              {...commonFieldProps}
              label={t('fEmpOfficeRoom')}
              error={!!error?.message}
              helperText={error?.message}
            />
          );
        }}
      />
    </Box>
  );
};
